import { all } from "redux-saga/effects";
import { getUserLoginSaga } from "../containers/Login/Store/saga";
import { getUserRegisterSaga } from "../containers/Register/Store/saga";
import { manageUsersSaga } from "../containers/users/Store/saga";
import { manageAzureSaga } from "../containers/azure/Store/saga";
import { manageAzureBillSaga } from "../containers/azurebilling/Store/saga";
import { manageAzureForecastBillSaga } from "../containers/azureForecastbilling/Store/saga";
import { manageAzureSubSaga } from "../containers/azuresubcription/Store/saga";
import { manageAzureActivityLogsSaga } from "../containers/azureactivitylogs/Store/saga";
import { manageAzureVmsSaga } from "../containers/azurevms/Store/saga";
import { manageAzureVmsImagesSaga } from "../containers/azurevmsimages/Store/saga";
import { manageAzureDBSaga } from "../containers/azuredatabases/Store/saga";
import { manageAzureStorageSaga } from "../containers/azurestorageaccounts/Store/saga";
import { manageAzureSiteSaga } from "../containers/azuresites/Store/saga";
import { manageAzureFunctionalAppSaga } from "../containers/azurefunctionalapp/Store/saga";
import { manageAzureLoadBalancerSaga } from "../containers/azureloadbalancer/Store/saga";
import { manageAzureAlertRulesSaga } from "../containers/azurealertrules/Store/saga";
import { manageAzureActiveAlertSaga } from "../containers/azureactivealert/Store/saga";
import { manageAzureMonitorStorageAccountSaga } from "../containers/azuremonitorstorageaccounts/Store/saga";
import { manageAzureMonitorApplicationsSaga } from "../containers/azuremonitorapplications/Store/saga";
import { manageAzureCDNSaga } from "../containers/azurecdn/Store/saga";
import { manageAzureMetricsFailedSaga } from "../containers/azuremetricsfailed/Store/saga";
import { manageAzureMetricsRequestSaga } from "../containers/azuremetricsrequest/Store/saga";
import { manageAzureMetricsResponseSaga } from "../containers/azuremetricsresponse/Store/saga";
import { manageAzureMetricsAvailabilitySaga } from "../containers/azuremetricsavailability/Store/saga";
import { manageAzureMetricsLogsSaga } from "../containers/azuremetricslogs/Store/saga";
import { manageAzureConsoleLogsSaga } from "../containers/azureconsolelogs/Store/saga";
import { manageAzureDashboardDetailsSaga } from "../containers/azuredashboarddetails/Store/saga";
import { manageAzureDatabasePerformanceInsightSaga } from "../containers/azuredatabaseperformanceinsight/Store/saga";
import { manageGCPAccountSaga } from "../containers/users/Store/gcpSaga";
import { manageGCPComputeInstancesSaga } from "../containers/gcpComputeInstances/Store/saga";
import { manageGCPCloudRunSaga } from "../containers/gcpCloudRun/Store/saga";
import { manageGCPSecretManagerSaga } from "../containers/gcpSecretManager/Store/saga";

export default function* rootSaga() {
  yield all([
    manageAzureMetricsFailedSaga(),
    manageAzureMetricsAvailabilitySaga(),
    manageAzureMetricsLogsSaga(),
    manageAzureMetricsRequestSaga(),
    manageAzureMetricsResponseSaga(),
    getUserLoginSaga(),
    getUserRegisterSaga(),
    manageUsersSaga(),
    manageAzureSaga(),
    manageAzureBillSaga(),
    manageAzureForecastBillSaga(),
    manageAzureSubSaga(),
    manageAzureActivityLogsSaga(),
    manageAzureVmsSaga(),
    manageAzureVmsImagesSaga(),
    manageAzureDBSaga(),
    manageAzureStorageSaga(),
    manageAzureSiteSaga(),
    manageAzureDatabasePerformanceInsightSaga(),
    manageAzureFunctionalAppSaga(),
    manageAzureLoadBalancerSaga(),
    manageAzureAlertRulesSaga(),
    manageAzureActiveAlertSaga(),
    manageAzureMonitorStorageAccountSaga(),
    manageAzureMonitorApplicationsSaga(),
    manageAzureCDNSaga(),
    manageAzureConsoleLogsSaga(),
    manageAzureDashboardDetailsSaga(),
    manageGCPAccountSaga(),
    manageGCPComputeInstancesSaga(),
    manageGCPCloudRunSaga(),
    manageGCPSecretManagerSaga(),
  ]);
}
